import React, { Component } from 'react'
import { Alert, Form, Icon, Input } from 'antd'
import { infoRequired, validatePassword } from '../../../utils/validators';
import { request } from '../../../utils/api';
import TagFlow from '../../../Components/TagFlow';

class FormResetPassword extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: null,
            message: '',
            success: false
        }
    }

    componentWillMount() {
        if (this.interval) {
            clearTimeout(this.interval)
        }
    }

    handleSuccess = () => {
        this.setState({
            success: true,
            loading: false,
            message: ''
        }, () => {
            this.interval = setTimeout(() => {
                this.setState({
                    success: false
                })
            }, 6000)
        })
    }

    handleSubmit = e => {
        e.preventDefault()
        this.props.form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                this.setState({
                    loading: true
                })
                try {
                    const response = await request('users/resetSenha', 'PUT', {
                        id: this.props.user.id,
                        senhaAtual: values.senha,
                        senhaNova: values.novaSenha
                    })
                    if (response.code === 11) {
                        this.handleSuccess()
                    } else {
                        this.setState({
                            loading: false,
                            message: response.message || 'Ops! Não conseguimos alterar sua senha no momento!'
                        })
                    }
                } catch(e) {
                    this.setState({
                        loading: false,
                        message: 'Ops! Não conseguimos alterar sua senha no momento!'
                    })
                }
            }
        })
    }

    render() {
        const { form } = this.props
        return this.state.success ? (
            <div className="senhaSuccess animated bounceInRight">
                <div>
                    <Icon type="unlock" />
                </div>
                <div>
                    <h2>Senha alterada!</h2>
                    <div>Você já pode utilizar sua nova senha para acessar sua conta no <TagFlow /></div>
                </div>
            </div>
        ) : (
            <div className="animated fadeIn">
                <Form layout="vertical" onSubmit={this.handleSubmit}>
                    {this.state.message && <Form.Item>
                        <Alert message={this.state.message} type="error" showIcon />
                    </Form.Item>}

                    <div style={{ textAlign: 'center' }}>
                        {this.state.loading && <Form.Item>
                            <Icon type="loading" />
                        </Form.Item>}
                    </div>

                    <Form.Item label="Senha Atual">
                        {form.getFieldDecorator('senha', {
                            rules: [
                                infoRequired
                            ]
                        })(
                            <Input.Password placeholder="Senha Atual" />
                        )}
                    </Form.Item>

                    <Form.Item label="Nova Senha">
                        {form.getFieldDecorator('novaSenha', {
                            rules: [
                                infoRequired,
                                validatePassword()
                            ]
                        })(
                            <Input.Password placeholder="Senha" />
                        )}
                    </Form.Item>

                    <Form.Item label="Confirme sua nova senha">
                        {form.getFieldDecorator('confirmSenha', {
                            rules: [
                                {
                                    validator: (_, value, callback) => {
                                        if (value && value !== form.getFieldValue('novaSenha')) {
                                            callback('As novas senhas não correspondem')
                                        } else {
                                            callback()
                                        }
                                    }
                                }
                            ]
                        })(
                            <Input.Password placeholder="Confirme sua nova senha" />
                        )}
                    </Form.Item>

                    <Form.Item>
                        <button type="submit" className="alterarSenhaSubmit">
                            Alterar Senha
                        </button>
                    </Form.Item>
                </Form>
            </div>
        )
    }
}

export default Form.create({ name: 'reset-password' })(FormResetPassword)